
import Helpers from './General/Helpers';
import Ajax from './General/Ajax';
import Messages from './General/Messages';
import Settings from './Pages/Settings';
import Conversions from './Pages/Conversions';
import Rules from './Pages/Rules';
import ThemeBuilder from './Pages/ThemeBuilder';
import Optimizations from './Pages/Optimizations';
import Dashboard from './Pages/Dashboard';
import Recaptcha from './Pages/Recaptcha';
import SystemStatus from './Pages/SystemStatus';
import Integrations from './Pages/Integrations';
import Builder from './Builder';
import OP3General from './OP3General';
import Cards from 'optimizepress-ui/src/js/components/cards';
import Unsplash from './MediaLibrary/Unsplash';
import MediaLibrary from './MediaLibrary/MediaLibrary';
//import FbCustomEvents from "./Pages/FbCustomEvents";

window.OPDashboard = {
    pages: {
        Settings: new Settings,
        Conversions: new Conversions,
        Rules: new Rules,
        Optimizations: new Optimizations,
        Dashboard: new Dashboard,
        Recaptcha: new Recaptcha,
        SystemStatus: new SystemStatus,
        Integrations: new Integrations,
        ThemeBuilder: new ThemeBuilder(),
    },
    Helpers: new Helpers,
    Ajax: new Ajax,
    Messages: new Messages,
    Unsplash: new Unsplash,
};

window.OP3General = new OP3General;
window.OPDashboard.pages.Builder = new Builder;

document.addEventListener("DOMContentLoaded", function() {
    new Cards();
    window.OPDashboard.MediaLibrary = new MediaLibrary();
});

